var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 401,
    viewBox: "0 0 456 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1219_12946",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 456,
    height: 401
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 401,
    fill: "#ECFFFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1219_12946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.481 277.51L75.7312 306.714L25 277.51L75.7312 248.287L126.481 277.51Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.212 248.286L126.481 277.51L75.7305 248.286L126.481 219.082L177.212 248.286Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.945 219.082L177.214 248.287L126.482 219.082L177.214 189.859L227.945 219.082Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.694 189.859L227.944 219.082L177.213 189.859L227.944 160.635L278.694 189.859Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.212 306.714L126.481 335.937L75.7305 306.714L126.481 277.51L177.212 306.714Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.945 277.51L177.214 306.714L126.482 277.51L177.214 248.287L227.945 277.51Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.694 248.286L227.944 277.51L177.213 248.286L227.944 219.082L278.694 248.286Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.425 219.082L278.694 248.287L227.943 219.082L278.694 189.859L329.425 219.082Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.944 335.938L177.213 365.161L126.463 335.938L177.213 306.714L227.944 335.938Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.675 306.714L227.944 335.937L177.213 306.714L227.944 277.51L278.675 306.714Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.425 277.51L278.675 306.714L227.943 277.51L278.675 248.287L329.425 277.51Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.157 248.286L329.426 277.51L278.676 248.286L329.426 219.082L380.157 248.286Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.675 365.161L227.944 394.365L177.213 365.161L227.944 335.938L278.675 365.161Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.425 335.938L278.675 365.161L227.943 335.938L278.675 306.714L329.425 335.938Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.157 306.714L329.426 335.937L278.676 306.714L329.426 277.51L380.157 306.714Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.888 277.51L380.157 306.714L329.426 277.51L380.157 248.287L430.888 277.51Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.334 248.185C260.145 248.185 266.478 241.87 266.478 234.079C266.478 226.289 260.145 219.974 252.334 219.974C244.523 219.974 238.191 226.289 238.191 234.079C238.191 241.87 244.523 248.185 252.334 248.185Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.04 239.773C262.028 235.796 263.317 230.161 261.931 225.102C266.777 230.246 266.679 238.317 261.64 243.343C256.609 248.361 248.533 248.467 243.373 243.662C248.429 245.03 254.061 243.742 258.04 239.773Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.163 248.538C375.504 248.538 388.751 235.326 388.751 219.028C388.751 202.731 375.504 189.519 359.163 189.519C342.821 189.519 329.574 202.731 329.574 219.028C329.574 235.326 342.821 248.538 359.163 248.538Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.344 230.165C379.451 221.082 381.573 207.714 376.805 196.598C377.705 197.292 378.57 198.044 379.389 198.86C390.545 209.987 390.545 228.051 379.389 239.178C368.231 250.305 350.116 250.306 338.958 239.18C338.145 238.361 337.397 237.505 336.707 236.618C347.849 241.377 361.243 239.243 370.344 230.165Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.508 229.782C135.899 229.782 154.05 211.679 154.05 189.347C154.05 167.015 135.899 148.912 113.508 148.912C91.1165 148.912 72.9648 167.015 72.9648 189.347C72.9648 211.679 91.1165 229.782 113.508 229.782Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.469 161.442L142.175 162.147L142.186 162.136C156.931 177.59 156.699 202.043 141.489 217.213C126.041 232.619 100.991 232.619 85.5435 217.213C84.0669 215.74 82.7431 214.167 81.5554 212.52C96.949 219.723 115.844 217.021 128.557 204.342C141.267 191.665 143.979 172.823 136.762 157.47C138.414 158.654 139.996 159.972 141.469 161.442Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.365 29.5688C355.568 43.13 432 127.973 432 230.637V277.51",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 277.509V230.637C25 127.934 101.489 43.0527 200.749 29.5488",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.388 23.5712V24.5712H240.388H240.464C241.544 24.5712 242.375 25.4458 242.375 26.4744V39.9974C242.375 41.0682 241.502 41.9007 240.464 41.9007H217.962C216.882 41.9007 216.051 41.0261 216.051 39.9974V26.4744C216.051 25.4036 216.924 24.5712 217.962 24.5712H218.192H219.192V23.5712V19.9994C219.192 14.4954 223.48 9.85217 228.859 9.63477H229.28C234.844 9.63477 239.388 14.1028 239.388 19.7129V23.5712ZM236.542 22.4948V19.6938C236.542 15.7201 233.258 12.448 229.28 12.448H228.686H228.639L228.592 12.4525C224.832 12.8096 222.018 16.0944 222.018 19.8466V23.4948V24.4948H223.018H235.542V23.5712H236.542V23.5521V23.4948V22.4948Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.58 113.776V148.596C240.77 146.781 245.347 143.821 249.465 140.077C254.693 135.34 258.734 129.725 261.74 123.345C264.843 116.737 266.586 109.822 266.624 100.54C266.624 99.2789 266.509 97.77 266.222 96.1465L235.58 113.795V113.776Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.581 148.539L213.27 135.818L213.384 101.036L235.523 113.776L235.581 148.539Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.064 83.3872L213.441 101.036L235.58 113.776L266.222 96.1462L244.064 83.3872Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 295.005C179.721 295.559 182.134 296.399 184.47 297.488C191.46 300.716 197.187 305.567 201.898 311.603C208.965 320.676 213.12 330.913 213.676 342.469C213.906 347.091 213.35 351.599 211.895 355.935L177.289 335.994V294.986L177.27 295.005Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.548 284.251C214.557 287.479 220.264 292.331 224.975 298.367C232.042 307.439 236.198 317.677 236.753 329.233C236.964 333.836 236.447 338.305 235.01 342.622L211.933 355.916C213.37 351.599 213.925 347.091 213.695 342.488C213.14 330.933 208.984 320.695 201.917 311.622C197.225 305.586 191.499 300.735 184.49 297.507C182.211 296.457 179.874 295.616 177.48 295.062L200.5 281.807C202.913 282.361 205.269 283.201 207.567 284.271L207.548 284.251Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryBlock);
export default __webpack_public_path__ + "static/media/industry-block.ab46c2423990287c4f5bcdc91896d12c.svg";
export { ForwardRef as ReactComponent };